import { useEffect, useRef, useCallback } from 'react';

/**
 * Generic polling hook. Calls fetchFn immediately on mount,
 * then every intervalMs milliseconds. Cleans up on unmount.
 */
export function usePolling(
  fetchFn: () => Promise<void>,
  intervalMs: number,
  enabled = true
) {
  const savedFn = useRef(fetchFn);
  savedFn.current = fetchFn;

  const refresh = useCallback(() => {
    savedFn.current();
  }, []);

  useEffect(() => {
    if (!enabled) return;

    // Fetch immediately
    savedFn.current();

    const id = setInterval(() => {
      savedFn.current();
    }, intervalMs);

    return () => clearInterval(id);
  }, [intervalMs, enabled]);

  return { refresh };
}
